import { createBrowserRouter, Navigate, Outlet } from 'react-router-dom';
import { Welcome } from './screens/Welcome.js';
import { Create } from './screens/Create.js';
import { Import } from './screens/Import.js';
import { Unlock } from './screens/Unlock.js';
import { WalletWiped } from './screens/WalletWiped.js';
import { Wallet } from './screens/Wallet.js';
import { Miner } from './screens/Miner.js';
import { Send } from './screens/Send.js';
import { Receive } from './screens/Receive.js';
import { History } from './screens/History.js';
import { Settings } from './screens/Settings.js';
import { Playground } from './screens/Playground.js';
import { ChangePin } from './screens/ChangePin.js';
import { ShowMnemonic } from './screens/ShowMnemonic.js';
import { Privacy } from './screens/Privacy.js';
import { Biometric } from './screens/Biometric.js';
import { AuthenticatedLayout } from './components/AuthenticatedLayout.js';
import { useAutoLock } from './hooks/useAutoLock.js';
import { useWalletStore } from './stores/walletStore.js';
import { useSessionStore } from './stores/sessionStore.js';

function Layout() {
  useAutoLock();
  return <Outlet />;
}

function RootResolver() {
  const wallets = useWalletStore((s) => s.wallets);
  const watched = useWalletStore((s) => s.watched);
  const unlocked = useSessionStore((s) => s.unlockedAt !== null);
  if (wallets.length === 0 && watched.length === 0)
    return <Navigate to="/welcome" replace />;
  if (wallets.length > 0 && !unlocked) return <Navigate to="/unlock" replace />;
  return <Navigate to="/wallet" replace />;
}

export const router = createBrowserRouter([
  {
    element: <Layout />,
    children: [
      { path: '/', element: <RootResolver /> },
      { path: '/welcome', element: <Welcome /> },
      { path: '/create', element: <Create /> },
      { path: '/import', element: <Import /> },
      { path: '/unlock', element: <Unlock /> },
      { path: '/wiped', element: <WalletWiped /> },
      { path: '/send', element: <Send /> },
      { path: '/receive', element: <Receive /> },
      { path: '/settings/change-pin', element: <ChangePin /> },
      { path: '/settings/show-mnemonic', element: <ShowMnemonic /> },
      { path: '/settings/privacy', element: <Privacy /> },
      { path: '/settings/biometric', element: <Biometric /> },
      { path: '/home', element: <Navigate to="/wallet" replace /> },
      {
        element: <AuthenticatedLayout />,
        children: [
          { path: '/wallet', element: <Wallet /> },
          { path: '/miner', element: <Miner /> },
          { path: '/history', element: <History /> },
          { path: '/settings', element: <Settings /> },
        ],
      },
      ...(import.meta.env.DEV || import.meta.env.VITE_ENABLE_PLAYGROUND === 'true'
        ? [{ path: '/playground', element: <Playground /> }]
        : []),
      { path: '*', element: <Navigate to="/" replace /> },
    ],
  },
]);
